/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmSablonaKonvenceGordic extends GContentBase<SeznamAdmSablonaKonvenceGordicObj> {
        private seznamObj: SeznamAdmSablonaKonvenceGordicObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmSablonaKonvenceGordicObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmSablonaKonvenceGordicNew",
                contentCaption: "jres:33000325", //RC 33000325 : �ablony konvence Gordic
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{cesta} - {soubor}"
                },
                gridSettings: {
                    columnOrder: "soubor,cesta,popis,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmSablonaKonvenceGordicObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSablonaKonvenceGordic", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmSablonaKonvenceGordic",
                newRecord: isNew,
                soubor: isNew == true ? null : data.soubor,
                cesta: isNew == true ? null : data.cesta
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmSablonaKonvenceGordic.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.soubor, data.cesta),
                nazev: ""
            }
        }
    }
}